$(function() {
	$('.modal').on('click',function(){
    $('.popupbg').fadeIn();
});

$('.batsu').on('click',function(){
    $('.popupbg').fadeOut();

});
});

//PAGETOP
$(document).ready(function () {
	$("#pageTop").hide();
	$(window).on("scroll", function () {
		if ($(this).scrollTop() > 100) {
			$("#pageTop").fadeIn("fast");
		} else {
			$("#pageTop").fadeOut("fast");
		}
		scrollHeight = $(document).height();
		scrollPosition = $(window).height() + $(window).scrollTop();
		footHeight = $("footer").innerHeight(); //footerの高さ（＝止めたい位置）
		if (scrollHeight - scrollPosition <= footHeight) {
			$("#pageTop").css({
				"position": "absolute",
				"bottom": footHeight + 20
			});
		} else {
			$("#pageTop").css({
				"position": "fixed",
				"bottom": "120px"
			});
		}
	});
	$('#pageTop').click(function () {
		$('body,html').animate({
			scrollTop: 0
		}, 400);
		return false;
	});
});

$(function() {
	$('#menu').hover(function() {
		$(this).find('.menu_content').stop().slideDown();
	}, function() {
		$(this).find('.menu_content').stop().slideUp();
	});
});

$(function() {
	$('.menu-list02').hover(function() {
		$(this).find('.menu_content02').stop().slideDown();
	}, function() {
		$(this).find('.menu_content02').stop().slideUp();
	});
});

$(function() {
	$('.changetext a').click(function() {
		$('.changetext a').toggleClass('active')

	});
});

$(function(){
    const button = document.getElementById('send');
    button.addEventListener('click',function(){
        button.classList.add('disable');
    });
});
